<template>
    <div>
        <Fieldset :legend="$t('searchHeader')" :toggleable="true">
            <div class="p-fluid p-mt-2 p-ml-3 p-mr-3 p-mb-2">
                <div class="p-formgrid p-grid p-col">
                    <div class="p-field p-col-8 p-lg-2">
                        <label for="isu_organize">{{ $t('isu_organize') }}</label>
                        <InputText id="isu_organize" type="text" v-model="selectedOrganize.name" disabled />
                    </div>
                    <div class="p-field p-lg-1">
                        <div>
                            <Button @click="showOrganize = true" icon="pi pi-ellipsis-h" class="p-button-secondary p-mr-2" />
                            <Button @click="selectedOrganize = {}" icon="pi pi-times" class="p-button-danger p-mt-4" />
                        </div>
                    </div>

                    <div class="p-field p-col-12 p-lg-2">
                        <label>{{ $t('starttime') }}</label>
                        <Calendar
                            dateFormat="dd/mm/yy"
                            :maxDate="actionEndTime"
                            :showButtonBar="true"
                            :monthNavigator="true"
                            :yearNavigator="true"
                            :showTime="true"
                            :showSeconds="true"
                            yearRange="2000:2050"
                            :locale="th"
                            v-model="actionStartTime"
                            :class="errorStartTime ? 'p-invalid' : null"
                        ></Calendar>
                        <small v-if="errorStartTime" class="p-error">{{ $t('invalid_starttime') }}</small>
                    </div>

                    <div class="p-field p-col-12 p-lg-2">
                        <label>{{ $t('endtime') }}</label>
                        <Calendar
                            dateFormat="dd/mm/yy"
                            :showButtonBar="true"
                            :monthNavigator="true"
                            :yearNavigator="true"
                            :showTime="true"
                            :showSeconds="true"
                            yearRange="2000:2050"
                            :locale="th"
                            v-model="actionEndTime"
                            :class="errorEndTime ? 'p-invalid' : null"
                        ></Calendar>
                        <small v-if="errorEndTime" class="p-error">{{ $t('invalid_endtime') }}</small>
                    </div>

                    <div class="p-field p-col">
                        <div class="p-formgrid p-grid p-jc-end p-mt-4">
                            <div class="p-field p-col-12 p-mt-2">
                                <!-- <Button
                    @click="exportCSV()"
                    :label="$t('exportBtn')"
                    class="p-button-info p-mr-3"
                    style="background-color: green;"
                  /> -->
                                <Button @click="clearSearchField()" :label="$t('clearBtn')" class="p-button-clear p-mr-3" />
                                <Button @click="initialData()" :label="$t('searchBtn')" class="p-button-info p-mr-2" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-formgrid p-grid p-col p-mt-1">
                    <text-footer :data="Data_text_Footer" :checkShow="text_Footer" :countItem="actionLogs_table.length.toLocaleString('en-US')" />
                </div>
            </div>
        </Fieldset>

        <Dialog
            :modal="true"
            :header="$t('OrganizeModalHeader')"
            :visible.sync="showOrganize"
            :style="{ width: '80%' }"
            :contentStyle="{ 'overflow-y': 'scroll' }"
        >
            <organize-table @selectOrganization="selectedOrganize_passValue"></organize-table>
        </Dialog>

        <div class="card p-fluid p-mt-2">
            <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" -->
            <DataTable
                :value="actionLogs_table"
                :scrollable="true"
                scrollHeight="500px"
                :lazy="true"
                :paginator="true"
                :rows="lazyParams.rows"
                :totalRecords="totalRecords"
                :loading="loading"
                :rowsPerPageOptions="[10, 20, 50, 100]"
                @page="onPage($event)"
                @sort="onSort($event)"
                :sortField="lazyParams.sortField"
                :sortOrder="lazyParams.sortOrder"
                dataKey="id"
                ref="dt"
                :exportFilename="`รายงานข้อมูลการใช้งานระบบ-${date}`"
                :rowHover="true"
                :selection.sync="selectedActionLogs"
                :filters="filters"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords} รายการ"
            >
                <!-- Doe : เพิ่ม ลำดับ 1/4 จบ  sortField="index" :sortOrder="1" -->
                <template #header>
                    <div class="p-grid p-col">
                        <!-- Doe : PDF 1/3 -->
                        <div class="table-header" style="padding: 7px">
                            <Button @click="exportCSV()" :label="$t('exportBtn')" class="p-button-info" style="background-color: green" />
                        </div>
                        <div class="table-header" style="padding: 7px">
                            <SplitButton
                                label="ส่งออก PDF"
                                :model="items"
                                class="p-button-raised p-button-danger"
                                style="background-color: #f33737"
                            ></SplitButton>
                        </div>
                        <!-- Doe : PDF 1/3 จบ -->

                        <!-- Doe PDF เลือกได้  1/5   -->
                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px">
                            <Button
                                @click="EditPDF()"
                                icon="pi pi-cog"
                                :label="'ตั้งค่า'"
                                style="background-color: #0288d1; border: 1px solid #0288d1"
                            />
                        </div>
                        <!-- Doe PDF เลือกได้  1/5 จบ  -->

                        <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
                            <!-- <span class="p-input-icon-left">
                <i class="pi pi-search" /><InputText
                  v-model="filters['global']"
                  :placeholder="$t('searchHeader')"
                />
              </span> -->

                            <!-- Doe ค้นหา  1/5 -->
                            <span class="p-input-icon-left" v-if="columns_disabled">
                                <i class="pi pi-search" />
                                <InputText v-model="filter" @input="searchTable()" :placeholder="$t('searchHeader')" />
                            </span>
                            <span class="p-input-icon-left" v-else>
                                <i class="pi pi-search" />
                                <InputText disabled v-model="filter" @input="searchTable()" :placeholder="$t('searchHeader')" />
                            </span>
                            <!-- Doe ค้นหา  1/5 จบ-->
                        </div>
                    </div>
                </template>
                <!-- <template #header>
          <div class="p-grid">
            <div class="table-header p-col-12 p-lg-3" style="margin-left: auto">
              <span class="p-input-icon-left">
                <i class="pi pi-search" /><InputText
                  v-model="filters['global']"
                  :placeholder="$t('searchHeader')"
                />
              </span>
            </div>
          </div>
        </template> -->
                <template #empty>{{ $t('TableEmpty') }}</template>
                <!--Doe : เพิ่มลำดับ 2/4-->
                <div v-if="columns_index == true">
                    <Column field="index" :header="'ลำดับ'" :sortable="true" :headerStyle="{ width: '8rem', textAlign: 'center' }">
                        <template #body="dataTable">
                            <div class="table_row">
                                {{ dataTable.data.index }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>
                <!--Doe : เพิ่มลำดับ 2/4 จบ-->

                <div v-if="columns_user_username == true">
                    <Column field="user_username" :header="$t('isu_username')" :sortable="true" headerStyle="width: 15rem">
                        <template #body="dataTable">
                            <div v-if="dataTable.data.user_username == null">-</div>
                            {{ dataTable.data.user_username }}
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>

                <div v-if="columns_user_fullname == true">
                    <Column field="user_fullname" :header="$t('isu_fullname')" :sortable="true" headerStyle="width: 15rem">
                        <template #body="dataTable">
                            <div v-if="dataTable.data.user_fullname == null">-</div>
                            {{ dataTable.data.user_fullname }}
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>

                <div v-if="columns_organize_name == true">
                    <Column field="organize_name" :header="$t('organize')" :sortable="true" headerStyle="width: 15rem">
                        <template #body="dataTable">
                            <div v-if="dataTable.data.organize_name == null">-</div>
                            {{ dataTable.data.organize_name }}
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>

                <div v-if="columns_action_time == true">
                    <Column field="action_time" :header="$t('action_time')" :sortable="true" headerStyle="width: 15rem">
                        <template #body="dataTable">
                            <!-- {{ formatTime(dataTable.data.action_time) }} -->
                            {{ dataTable.data.action_time }}
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>

                <div v-if="columns_topic == true">
                    <Column field="topic" :header="$t('action_topic')" :sortable="true" headerStyle="width: 15rem">
                        <template #body="dataTable">
                            <!-- {{
                                dataTable.data.topic.split(' ')[0] == 'Add'
                                    ? 'เพิ่มข้อมูล'
                                    : dataTable.data.topic.split(' ')[0] == 'Edit'
                                    ? 'แก้ไขข้อมูล'
                                    : 'ลบข้อมูล'
                            }} -->
                            <!-- {{ formatTopic(dataTable.data.topic) }} -->
                            {{ dataTable.data.topic }}
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>
                <!-- รอคอนเฟิร์ม-->
                <div v-if="columns_detail == true">
                    <Column field="detail" :header="$t('action_logs_details')" :sortable="true" headerStyle="width: 15rem">
                        <template #body="dataTable">
                            <div @click="showDetailDialog(dataTable.data)" style="cursor: pointer; color: #2196f3; text-decoration: underline">
                                รายละเอียด
                            </div>
                        </template>
                    </Column>
                </div>
            </DataTable>
        </div>

        <Dialog :header="$t('json')" :visible.sync="displayInfo" :style="{ width: 'max-content' }">
            <div class="p-mt-5 p-mb-5">
                <pre id="json"></pre>
            </div>
        </Dialog>

        <Dialog
            :modal="true"
            :header="$t('action_logs_deep_details')"
            :visible.sync="showLogsDetail"
            :style="{ width: '90%', maxWidth: '1200px' }"
            :contentStyle="{ 'overflow-y': 'auto', 'max-height': '80vh' }"
        >
            <div class="detail-content p-mt-5 p-mb-5">
                <!-- Replace the empty div with v-html binding -->
                <div v-html="formattedContent"></div>
            </div>
            <template #footer>
                <Button @click="showLogsDetail = false" :label="$t('ปิด')" icon="pi pi-times" class="p-button-text" />
            </template>
        </Dialog>

        <!-- Doe PDF เลือกได้  -->
        <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF" :style="{ width: '25rem' }" :contentStyle="{ 'overflow-y': 'visible' }">
            <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
            <div style="margin: 2.5rem 1rem 0 1rem">
                <div class="p-formgrid p-grid">
                    <div class="p-field p-col-12">
                        <MultiSelect
                            v-model="columnsSelectorDialog"
                            :options="columns"
                            optionLabel="title"
                            :placeholder="$t('placeholderSelectBox')"
                            :filter="true"
                            class="multiselect-custom"
                            :clearFilterMultiSelect="multiSelectClearFilerValue"
                        >
                            <template #value="slotProps">
                                <div class="item item-value" v-for="option of slotProps.value" :key="option.dataKey">
                                    <div>{{ option.title }}</div>
                                </div>
                                <template v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ $t('placeholderSelectBox') }}
                                </template>
                            </template>
                            <template #option="slotProps">
                                <div class="item">
                                    <div>{{ slotProps.option.title }}</div>
                                </div>
                            </template>
                        </MultiSelect>
                        <div style="margin-top: 1rem; display: flex; justify-content: flex-end">
                            <Button
                                @click="
                                    ClearEditPDF();
                                    multiSelectClearFilerValue += 1;
                                "
                                class="p-button-clear"
                                :label="'ล้างข้อมูล'"
                                style="margin-right: 1rem"
                            />
                            <Button @click="SelectAllEditPDF()" class="p-button-info" :label="'เลือกทั้งหมด'" />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div>
                    <Button @click="CloseEditPDF()" :label="'ยกเลิก'" icon="pi pi-times" class="p-button-text" />
                    <Button @click="SaveEditPDF()" :label="'บันทึก'" icon="pi pi-check" class="p-button-text" />
                </div>
            </template>
        </Dialog>
        <!-- Doe PDF เลือกได้ -->
    </div>
</template>

<script>
import organizeTable from '../../Information/OrganizeTable.vue';
import moment from 'moment';
// Doe : PDF 2/3
// เพิ่ม pdf กับ font
// import { jsPDF } from "jspdf";
// import {font} from '../../../../public/assets/font/Sarabun-Regular-normal';
// Doe : PDF 2/3 จบ
import textFooter from '../../../mixins/textFooter_Search_html';

export default {
    name: 'report-logs',
    components: {
        organizeTable,
        textFooter
    },
    data() {
        return {
            searchTimeout: null,
            searchDelay: 500,
            lazyParams: {
                page: 1,
                rows: 10,
                sortField: 'index',
                sortOrder: 1
            },
            totalRecords: 0,
            actionLogs_table: [],
            loading: false,
            formattedContent: '',
            summaryTable: [],
            dialogHeader: 'รายละเอียด',
            currentDetail: null,
            showLogsDetail: false,

            multiSelectClearFilerValue: 0,
            date: moment().locale('th').add(543, 'year').format('l'),
            // Doe ค้นหา  2/5
            filter: '',
            cou: false,
            cloneTable: [],
            // Doe ค้นหา  2/5 จบ

            selectedActionLogs: null,
            // actionLogs_table: [],
            filters: {},
            showOrganize: false,
            selectedOrganize: {
                id: null,
                name: ''
            },
            dateYear: '',
            actionStartTime: null,
            actionEndTime: null,
            // loading: false,
            displayInfo: false,
            infoText: null,

            errorStartTime: false,
            errorEndTime: false,

            // Doe PDF เลือกได้  2/5
            setPDF_Hor: 'l',
            setPosition_Hor: [802, 34, 802, 570],
            setPDF_Ver: 'p',
            setPosition_Ver: [570, 34, 575, 815],
            setPDF_Styles: 'grid',
            setnamePDF: 'ตารางรายงานข้อมูลการใช้งานระบบ',
            setPDF_fillColor: [95, 154, 250],
            setPDF_Margin: { left: 15, right: 15 },

            PDF_minCellWidthVer: 70,
            PDF_FontHeaderVer: 15,
            PDF_FontBodyVer: 12,

            PDF_BodySizeSelect: {},
            PDF_BodySize: {
                index: { cellWidth: 35 },
                user_fullname: { cellWidth: 80 }
            },

            PDF_minCellWidthHor: 70,
            PDF_FontHeaderHor: 15,
            PDF_FontBodyHor: 12,

            PDF_BodySizeHorSelect: {},
            PDF_BodySizeHor: {
                index: { cellWidth: 35 }
            },
            columns: [
                { title: 'ลำดับ', dataKey: 'index' },
                { title: 'ชื่อผู้ใช้งาน', dataKey: 'user_username' },
                { title: 'ชื่อ-นามสกุลเจ้าหน้าที่', dataKey: 'user_fullname' },
                { title: 'สังกัด', dataKey: 'organize_name' },
                { title: 'วันที่-เวลาที่จัดการข้อมูล', dataKey: 'action_time' },
                { title: 'การจัดการ', dataKey: 'topic' }
            ],

            columnsSelector: null,
            columnsSelectorDialog: null,

            displayEditPDF: false,

            columns_index: true,
            columns_user_username: true,
            columns_user_fullname: true,
            columns_organize_name: true,
            columns_action_time: true,
            columns_topic: true,
            columns_detail: true,

            columns_disabled: true,
            GetData_ColumnsSearch: [],
            // Doe PDF เลือกได้  2/5  จบ

            // Doe : PDF 3/3
            //
            text_Footer: false,
            Clone_Data_text_Footer: [],
            Data_text_Footer: [
                {
                    DataName: 'สังกัด',
                    textShow: ''
                },
                {
                    DataName: 'เวลาเริ่มต้น',
                    textShow: ''
                },
                {
                    DataName: 'เวลาสิ้นสุด',
                    textShow: ''
                }
            ],

            items: [
                {
                    label: ' แนวตั้ง',
                    command: async () => {
                        try {
                            await this.initialAllData(); // Search all data before export
                            this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวตั้ง', life: 3000 });

                            let columns = this.columnsSelector;

                            const Body_setCenter = ['index'];

                            const PintPDF = {
                                streak: this.setPDF_Ver,
                                setPosition: this.setPosition_Ver,
                                PDF_Styles: this.setPDF_Styles,
                                data: this.$refs.dt.processedData,
                                columns: columns,
                                columnsStyles: this.PDF_BodySizeSelect,
                                FileName: this.setnamePDF,
                                checkBody_Center: true,
                                Body_Center: Body_setCenter,
                                Col_FontSize: this.PDF_FontHeaderVer,
                                Body_FontSize: this.PDF_FontBodyVer,
                                minCell: this.PDF_minCellWidthVer,
                                marginPDF: this.setPDF_Margin,
                                fillColorPDF: this.setPDF_fillColor
                            };
                            this.printPDF(PintPDF);
                        } catch (error) {
                            this.$toast.add({
                                severity: 'error',
                                summary: 'Error',
                                detail: 'Failed to generate PDF',
                                life: 3000
                            });
                            console.error('Error generating PDF:', error);
                        }
                    }
                },
                {
                    label: 'แนวนอน',
                    command: async () => {
                        try {
                            await this.initialAllData(); // Search all data before export
                            this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวนอน', life: 3000 });

                            let columns = this.columnsSelector;

                            const Body_setCenter = ['index'];

                            const PintPDF = {
                                streak: this.setPDF_Hor,
                                setPosition: this.setPosition_Hor,
                                PDF_Styles: this.setPDF_Styles,
                                data: this.$refs.dt.processedData,
                                columns: columns,
                                columnsStyles: this.PDF_BodySizeHorSelect,
                                FileName: this.setnamePDF,
                                checkBody_Center: true,
                                Body_Center: Body_setCenter,
                                Col_FontSize: this.PDF_FontHeaderHor,
                                Body_FontSize: this.PDF_FontBodyHor,
                                minCell: this.PDF_minCellWidthHor,
                                marginPDF: this.setPDF_Margin,
                                fillColorPDF: this.setPDF_fillColor
                            };
                            this.printPDF(PintPDF);
                        } catch (error) {
                            this.$toast.add({
                                severity: 'error',
                                summary: 'Error',
                                detail: 'Failed to generate PDF',
                                life: 3000
                            });
                            console.error('Error generating PDF:', error);
                        }
                    }
                }
            ]
            // Doe : PDF 3/3 จบ
        };
    },
    watch: {
        selectedOrganize(val) {
            if (val != '') {
                this.showOrganize = false;
            }
        },

        displayInfo(val) {
            if (val) {
                setTimeout(() => {
                    document.getElementById('json').textContent = JSON.stringify(JSON.parse(this.infoText), undefined, 2);
                }, 500);
            }
        },

        actionStartTime(val) {
            if (val) {
                this.errorStartTime = false;
            }
        },
        actionEndTime(val) {
            if (val) {
                this.errorEndTime = false;
            }
        },

        // Doe PDF เลือกได้
        columnsSelector(val) {
            if (val.length == 0) {
                this.actionLogs_table = [];
            } else {
                this.actionLogs_table = this.cloneTable;
            }
        }
    },
    created() {
        const yy = new Date();
        const yyyy = parseInt(yy.getFullYear()) + 543;
        this.dateYear = yyyy;
        // Doe PDF เลือกได้  4/5
        this.columnsSelector = this.columns;
        this.PDF_BodySizeSelect = this.PDF_BodySize;
        this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;

        // Doe PDF เลือกได้  4/5  จบ

        this.initialData();

        this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer);
    },
    mounted() {},
    methods: {
        // Method to show detail dialog and format data
        showDetailDialog(rowData) {
            try {
                // Set dialog header based on topic
                if (rowData.topic.includes('เพิ่มข้อมูล')) {
                    this.dialogHeader = 'รายละเอียดการเพิ่มข้อมูล';
                } else if (rowData.topic.includes('แก้ไขข้อมูล')) {
                    this.dialogHeader = 'รายละเอียดการแก้ไขข้อมูล';
                } else if (rowData.topic.includes('ลบข้อมูล')) {
                    this.dialogHeader = 'รายละเอียดการลบข้อมูล';
                } else {
                    this.dialogHeader = 'รายละเอียด';
                }

                // Store current detail for processing
                this.currentDetail = rowData.detail;

                // Format the content before showing the dialog
                this.formatDetailContent(rowData.detail, rowData.topic);

                // Now show the dialog after content is formatted
                this.showLogsDetail = true;
            } catch (e) {
                console.error('Error preparing dialog:', e);
            }
        },

        // Function to format the detail content
        formatDetailContent(detailData, topic) {
            try {
                // Parse the JSON string to an object
                const parsedData = typeof detailData === 'string' ? JSON.parse(detailData) : detailData;

                let formattedHTML = '';

                // Create header with styling
                formattedHTML += '<div style="font-family: Arial, sans-serif; padding: 15px;">';

                // Generate content based on topic type
                if (topic.includes('เพิ่มข้อมูล')) {
                    // For "Add" action - show all data
                    formattedHTML += `<div style="background-color: #555; color: white; padding: 10px; border-radius: 5px; font-weight: bold; display: inline-block; margin-bottom: 10px;">เพิ่มข้อมูล </div>`;
                    formattedHTML += this.formatDataSection(parsedData.updated_data || parsedData, 'ข้อมูลที่เพิ่ม');
                } else if (topic.includes('ลบข้อมูล')) {
                    // For "Delete" action - show all data
                    formattedHTML += `<div style="background-color: #555; color: white; padding: 10px; border-radius: 5px; font-weight: bold; display: inline-block; margin-bottom: 10px;">ลบข้อมูล </div>`;
                    formattedHTML += this.formatDataSection(parsedData.previous_data || parsedData, 'ข้อมูลที่ถูกลบ');
                } else if (topic.includes('แก้ไขข้อมูล')) {
                    formattedHTML += `<div style="background-color: #555; color: white; padding: 10px; border-radius: 5px; font-weight: bold; display: inline-block; margin-bottom: 10px;">แก้ไขข้อมูล</div>`;

                    // Check if data has previos_data and updated_data properties
                    if (parsedData.previos_data && parsedData.updated_data) {
                        formattedHTML += this.compareData(parsedData.previos_data, parsedData.updated_data);
                    } else if (parsedData.previous_data && parsedData.updated_data) {
                        formattedHTML += this.compareData(parsedData.previous_data, parsedData.updated_data);
                    } else {
                        formattedHTML += this.formatDataSection(parsedData, 'ข้อมูลรายละเอียด');
                    }
                } else {
                    // Default case
                    formattedHTML += this.formatDataSection(parsedData, 'ข้อมูลรายละเอียด');
                }

                formattedHTML += '</div>';

                // Set the formatted HTML content to the reactive property
                this.formattedContent = formattedHTML;
            } catch (e) {
                console.error('Error parsing JSON:', e);
                this.formattedContent = `<div style="color: red; padding: 15px;">Error parsing detail data: ${e.message}</div>`;
            }
        },

        formatDataSection(data, title) {
            if (!data) return '';

            // Create a container with similar styling to compareData
            let html = `<div style="display: flex; flex-direction: row; margin-top: 15px;">
        <div style="flex: 1;">
            <div style="background-color: #555; color: white; text-align: center; padding: 10px; font-weight: bold; margin-bottom: 1px;">${title}</div>
            <div style="background-color: #f5f5f5; border: 1px solid #ddd; border-radius: 0px; padding: 0px;">
                <table style="width: 100%; border-collapse: collapse;">`;

            // Filter out excluded keys as in compareData
            const excludedKeys = [
                'user_id',
                'ev_amount',
                'evacuation_id',
                'evacuation_organize',
                'location_id',
                'disaster_id',
                'risklevel_id',
                'riskarea_id',
                'riskarea_organize',
                'organize_id',
                'organize_type_id',
                'organize_main',
                'response_area_id',
                'communication_id',
                'prevent_id',
                'prevent_type_id',
                'prevent_organize',
                'user_organize',
                'course_id',
                'course_training_table',
                'course_level_id',
                'officer_id',
                'officer_prefix',
                'officer_level_id',
                'editor',
                'specialist_id',
                'training_history_table',
                'update_info',
                'officer_organize',
                'officer_mobile_phone',
                'officer_phone',
                'officer_startwork',
                'update_date',
                'volunteer_id',
                'device_id',
                'device_type_id',
                'device_unit_id',
                'incident_equipment_table',
                'incident_id',
                'org_id'
            ];

            // Process each property in the data, excluding specific keys
            Object.entries(data)
                .filter(([key]) => !excludedKeys.includes(key))
                .forEach(([key, value]) => {
                    // Format the key for display using the same formatKeyName method
                    const displayKey = this.formatKeyName(key);

                    // Format the value using the same formatValue method
                    const displayValue = this.formatValue(value);

                    // Use the same styling as compareData
                    const tdStyle = 'padding: 8px; border-bottom: 1px solid #ddd;';

                    html += `<tr>
                <td style="${tdStyle} font-weight: bold; width: 30%; border-right: 1px dotted #ccc;">${displayKey}</td>
                <td style="${tdStyle}">${displayValue}</td>
            </tr>`;
                });

            html += `</table></div></div></div>`;
            return html;
        },

        // Helper function to compare previous and updated data
        compareData(previous, updated) {
            if (!previous || !updated) return '';

            const excludedKeys = [
                'user_id',
                'ev_amount',
                'evacuation_id',
                'evacuation_organize',
                'location_id',
                'disaster_id',
                'risklevel_id',
                'riskarea_id',
                'riskarea_organize',
                'organize_id',
                'organize_type_id',
                'organize_main',
                'response_area_id',
                'communication_id',
                'prevent_id',
                'prevent_type_id',
                'prevent_organize',
                'user_organize',
                'course_id',
                'course_training_table',
                'course_level_id',
                'officer_id',
                'officer_prefix',
                'officer_level_id',
                'editor',
                'specialist_id',
                'training_history_table',
                'update_info',
                'officer_organize',
                'officer_mobile_phone',
                'officer_phone',
                'officer_startwork',
                'update_date',
                'volunteer_id',
                'device_id',
                'device_type_id',
                'device_unit_id',
                'incident_equipment_table',
                'incident_id',
                'org_id'
            ];

            // Create the container with two columns
            let html = `<div style="display: flex; flex-direction: row; margin-top: 15px; gap: 20px;">
                <div style="flex: 1;">
                    <div style="background-color: #555; color: white; text-align: center; padding: 10px; font-weight: bold; margin-bottom: 1px;">ข้อมูลก่อนปรับแก้</div>
                    <div style="background-color: #f5f5f5; border: 1px solid #ddd; border-radius: 0px; padding: 0px;">
                        <table style="width: 100%; border-collapse: collapse;">`;

            // Create a set of all keys from both objects
            const allKeys = new Set([
                ...Object.keys(previous).filter((key) => !excludedKeys.includes(key)),
                ...Object.keys(updated).filter((key) => !excludedKeys.includes(key))
            ]);

            // Process each key in previous data
            allKeys.forEach((key) => {
                const prevValue = previous[key];
                const newValue = updated[key];
                const hasChanged = JSON.stringify(prevValue) !== JSON.stringify(newValue);

                const displayKey = this.formatKeyName(key);
                const displayValue = this.formatValue(prevValue);

                const rowStyle = hasChanged ? 'background-color: #FFCDD2;' : '';
                const tdStyle = 'padding: 8px; border-bottom: 1px solid #ddd;';

                html += `<tr style="${rowStyle}">
                <td style="${tdStyle} font-weight: bold; width: 30%; border-right: 1px dotted #ccc;">${displayKey}</td>
                <td style="${tdStyle}">${displayValue}</td>
            </tr>`;
            });

            html += `</table></div></div>
             <div style="flex: 1;">
                <div style="background-color: #555; color: white; text-align: center; padding: 10px; font-weight: bold; margin-bottom: 1px;">ข้อมูลหลังปรับแก้</div>
                <div style="background-color: #f5f5f5; border: 1px solid #ddd; border-radius: 0px; padding: 0px;">
                    <table style="width: 100%; border-collapse: collapse;">`;

            // Process each key in updated data
            allKeys.forEach((key) => {
                const prevValue = previous[key];
                const newValue = updated[key];
                const hasChanged = JSON.stringify(prevValue) !== JSON.stringify(newValue);

                const displayKey = this.formatKeyName(key);
                const displayValue = this.formatValue(newValue);

                // Use a subtle green background for changed fields
                const rowStyle = hasChanged ? 'background-color: #e8f5e9;' : '';
                const tdStyle = 'padding: 8px; border-bottom: 1px solid #ddd;';

                // If there's a green field in the screenshot, add a green border
                const valueCellStyle = hasChanged ? `${tdStyle} border: 1px solid #4CAF50;` : tdStyle;

                html += `<tr style="${rowStyle}">
                <td style="${tdStyle} font-weight: bold; width: 30%; border-right: 1px dotted #ccc;">${displayKey}</td>
                <td style="${valueCellStyle}">${displayValue}</td>
            </tr>`;
            });

            html += `</table></div></div></div>`;
            return html;
        },

        // Helper function to format key names for better display
        formatKeyName(key) {
            // Map of field names to Thai translations
            const keyTranslations = {
                ev_id: 'รหัสอุปกรณ์',
                ev_code: 'หมายเลขอุปกรณ์',
                ev_community: 'ชุมชน',
                ev_name: 'ชื่ออุปกรณ์',
                ev_lat: 'ละติจูด',
                ev_lon: 'ลองจิจูด',
                ev_standard_name: 'ชื่อมาตรฐาน',
                ev_organize: 'หน่วยงาน',
                ev_group: 'กลุ่มเครื่องมือ',
                ev_type: 'ประเภทเครื่องมือ',
                ev_number: 'หมายเลขครุภัณฑ์',
                ev_amount: 'จำนวน',
                ev_status: 'สถานะ',
                ev_license_plate: 'เลขทะเบียน',
                ev_sidecar_number: 'หมายเลขข้างรถ',
                ev_car_brand: 'ยี่ห้อรถ',
                ev_received_date: 'วันที่ได้รับ',
                ev_date: 'วันที่ปรับปรุงล่าสุด',
                ev_response_name: 'ชื่อผู้รับผิดชอบ',
                ev_response_position: 'ตำแหน่งผู้รับผิดชอบ',
                ev_response_phone: 'เบอร์โทรผู้รับผิดชอบ',
                ev_detail: 'รายละเอียด',
                ev_maintenance_table: 'ตารางการซ่อมบำรุง',
                ev_maintenance_table2: 'ตารางการซ่อมบำรุง 2',
                ev_borrowing_history: 'ประวัติการยืม',
                ev_vehicledevice_table: 'ตารางอุปกรณ์ประจำรถ',
                tel_detail: 'รายละเอียดเบอร์โทร',
                remind_check: 'แจ้งเตือนการตรวจสอบ',
                date_update: 'วันที่ปรับปรุงข้อมูล',
                equipment_community: 'ชุมชน',
                location_id: 'รหัสสถานที่',
                event_lat: 'ละติจูด',
                event_lon: 'ลองจิจูด',
                pipe_size: 'ขนาด',
                road_name: 'ชื่อถนน',
                soi_name: 'ซอย',
                fire_station: 'สถานีดับเพลิง',
                status: 'สถานะ',
                inspec_details: 'รายละเอียดการตรวจสอบ',
                inspec_result: 'ผลการตรวจสอบ',
                location: 'สถานที่',
                province: 'จังหวัด',
                amphur: 'เขต',
                tambon: 'แขวง',
                community_name: 'ชุมชน',
                code: 'รหัส',
                edit_by: ' ผู้แก้ไข',
                create_by: 'ผู้สร้าง',
                date_create: 'วันที่สร้าง',
                place_name: 'ชื่อสถานที่',
                type: 'ประเภท',
                location_type: 'ประเภทสถานที่',
                extinguisher_size: 'ขนาดถังดับเพลิง',
                extinguisher_status: 'สถานะถังดับเพลิง',
                latch_lock: 'สลักล็อค',
                joystick: 'คันบังคับ',
                pressure_gauge: 'เกจความดัน',
                line_spray: 'สายฉีด',
                chassis: 'ตัวถัง',
                details: 'รายละเอียด',
                lat: 'ละติจูด',
                lon: 'ลองจิจูด',
                date_expire: 'วันหมดอายุ',
                prefix_name: 'คำนำหน้า',
                volunteer_sex: 'เพศ',
                volunteer_firstname: 'ชื่อ',
                volunteer_lastname: 'นามสกุล',
                birth_date: 'วันเกิด',
                volunteer_age: 'อายุ',
                volunteer_tel: 'เบอร์โทรศัพท์',
                volunteer_job: 'อาชีพ',
                course_start_date: 'วันเริ่มอบรม',
                course_end_date: 'วันสิ้นสุดอบรม',
                position_committee: 'ดำรงตำแหน่งของคณะกรรมการประสานงานศูนย์ อปพร.',
                response_organize: 'หน่วยงานที่รับผิดชอบ',
                volunteer_local_address: 'ที่อยู่ตามทำเบียนบ้าน',
                volunteer_current_address: 'ที่อยู่ปัจจุบัน',
                volunteer_education_level: 'ระดับการศึกษา',
                course_history: 'ประวัติการอบรม',
                volunteer_skill: 'ความชำนาญ',
                other_skill: 'ความชำนาญอื่นๆ',
                volunteer_professional: 'เชี่ยวชาญด้าน',
                other_professional: 'เชี่ยวชาญด้านอื่นๆ',
                work_status: 'สถานะการปฏิบัติงาน',
                created_by: 'ผู้สร้าง',
                updated_by: 'ผู้ปรับปรุง',
                volunteer_number: 'หมายเลขอาสาสมัคร',
                volunteer_community: 'ชุมชน',
                evacuation_name: 'ชื่อพื้นที่อพยพ',
                evacuation_location: 'ที่ตั้ง',
                evacuation_main_access: 'การเข้าถึงหลัก',
                evacuation_temp_access: 'การเข้าถึงรอง',
                evacuation_contact_name: 'ชื่อผู้ติดต่อ',
                evacuation_contact_phone: 'เบอร์โทรศัพท์ผู้ติดต่อ (โทรศัพท์มือถือ)',
                evacuation_lat: 'ละติจูด',
                evacuation_lon: 'ลองจิจูด',
                evacuation_detail: 'ข้อมูลเพิ่มเติม',
                evacuation_entry: 'ทางเข้า',
                evacuation_exit: 'ทางออก',
                evacuation_area: 'พื้นที่ (ไร่)',
                evacuation_capacity: 'ความจุ (คน)',
                risklevel_number: 'ระดับ',
                risklevel_detail: 'คำอธิบาย',
                riskarea_name: 'ชื่อพื้นที่',
                riskarea_location: 'ที่ตั้ง',
                disaster_level: 'ระดับความเสี่ยง',
                riskarea_lat: 'ละติจูด',
                riskarea_lon: 'ลองจิจูด',
                organize_code: 'รหัสสังกัด/หน่วยงาน',
                organize_name: 'ชื่อสังกัด/หน่วยงาน *',
                organize_location: 'ที่ตั้ง',
                organize_phone: 'เบอร์โทรศัพท์ผู้ติดต่อ (สำนักงาน)',
                organize_fax: 'เบอร์โทรสาร (Fax)',
                organize_email: 'อีเมล',
                organize_lat: 'ละติจูด',
                organize_lon: 'ลองจิจูด',
                organize_website: 'เว็บไซต์',
                organize_contact_name: 'ชื่อผู้ติดต่อ',
                organize_contact_phone: 'เบอร์โทรศัพท์ผู้ติดต่อ (โทรศัพท์มือถือ)',
                prevent_name: 'ชื่อระบบป้องกัน',
                prevent_location: 'ที่ตั้ง',
                prevent_contact_name: 'ชื่อผู้ติดต่อ',
                prevent_contact_phone: 'เบอร์โทรศัพท์ผู้ติดต่อ (โทรศัพท์มือถือ)',
                prevent_lat: 'ละติจูด',
                prevent_lon: 'ลองจิจูด',
                prevent_detail: 'ข้อมูลเพิ่มเติม',
                course_name: 'ชื่อหลักสูตร',
                course_detail: 'ข้อมูลเพิ่มเติม',
                officer_firstname: 'ชื่อ',
                officer_lastname: 'นามสกุล',
                officer_position: 'ตำแหน่ง',
                officer_fax: 'แฟกซ์',
                officer_email: 'อีเมล',
                officer_radio_signal: 'คลื่นวิทยุ',
                officer_response_signal: 'สัญญาณเรียกขาน',
                secretary_name: 'ชื่อเลขา',
                secretary_phone: 'เบอร์โทรศัพท์เลขา',
                officer_detail: 'รายละเอียดเพิ่มเติม',
                device_name: 'ชื่ออุปกรณ์',
                incident_name: 'ชื่อชุดเผชิญเหตุ',
                incident_level: 'ระดับความรุนแรง',
                disaster_detail: 'ลักษณะที่เกิดเหตุ',
                org_name: 'ชื่อสถานประกอบการ',
                org_owner_name: 'ชื่อผู้ประกอบการ',
                org_address: 'ที่อยู่ ',
                org_coordinator_name: 'ชื่อผู้ประสาน',
                io_lat: 'ละติจูด',
                io_lon: 'ลองจิจูด',
                date_create_form: 'วันที่สร้างข้อมูล',
                date_update_form: 'วันที่ปรับปรุงข้อมูลล่าสุด',
                io_location_detail: 'รายละเอียดที่ยู่',
                contact_phone_office: 'เบอร์โทรศัพท์ผู้ติดต่อ (สำนักงาน)',
                contact_phone: 'เบอร์โทรศัพท์ผู้ติดต่อ (โทรศัพท์มือถือ)',
                FireStationSelected: 'สถานีดับเพลิง',
                io_selectedProvince: 'จังหวัด',
                io_selectedAmphur: 'เขต',
                io_selectedTambon: 'แขวง',
                io_postcode: 'รหัสไปรษณีย์',
                RiskLevel_type: 'ระดับความเสี่ยง',
                org_id: 'รหัสสถานประกอบการ',
                business_id: 'รหัสธุรกิจ',
                check_update: 'ตรวจสอบปรับปรุงล่าสุด',
                organize_id: 'รหัสหน่วยงานที่รับผิดชอบ',
                horse_power: 'แรงม้า',
                total_worker: 'คนงานรวม',
                men_worker: 'ชาย',
                women_worker: 'หญิง',
                orgBusinessDataDetail: 'รายละเอียดสถานประกอบการ',
                hspLicense: 'ใบอนุญาตประกอบกิจการที่เป็นอันตรายต่อสุขภาพ',
                factoryLicense: 'ใบอนุญาตประกอบกิจการโรงงาน',
                orgBusinessDetail: 'ลักษณะการประกอบกิจการ'
            };

            return keyTranslations[key] || key;
        },

        formatValue(value) {
            if (value === null || value === undefined) {
                return '<span style="color: #999;">- ไม่มีข้อมูล -</span>';
            }

            // Handle objects directly (not just JSON strings)
            if (typeof value === 'object') {
                return this.formatObjectValue(value);
            }

            // Status codes translation
            if (typeof value === 'string' && value.length === 1 && /^[1-5]$/.test(value)) {
                const statusMap = {
                    1: 'พร้อมใช้',
                    2: 'ซ่อม',
                    3: 'ชำรุด',
                    4: 'รอจำหน่าย',
                    5: 'จำหน่าย'
                };

                if (statusMap[value]) {
                    return statusMap[value];
                }
            }

            if (typeof value === 'string' && ['device', 'vehicle'].includes(value)) {
                const evGroupMap = {
                    device: 'เครื่องมืออุปกรณ์',
                    vehicle: 'ยานพาหนะ'
                };

                if (evGroupMap[value]) {
                    return evGroupMap[value];
                }
            }

            if (typeof value === 'string' && ['TRUE', 'FALSE'].includes(value)) {
                const extinguisherStatusMap = {
                    TRUE: 'พร้อมใช้',
                    FALSE: 'ชำรุด'
                };

                if (extinguisherStatusMap[value]) {
                    return extinguisherStatusMap[value];
                }
            }

            // Try to parse potential JSON strings
            if (typeof value === 'string' && (value.startsWith('[') || value.startsWith('{'))) {
                try {
                    const parsedJson = JSON.parse(value);
                    return this.formatObjectValue(parsedJson);
                } catch (e) {
                    console.warn('JSON parsing failed for:', value);
                }
            }

            // Format dates if applicable
            if (typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2}(T|\s)/)) {
                try {
                    // Use moment for Thai calendar (Buddhist Era - add 543 years)
                    if (typeof moment !== 'undefined') {
                        return moment(value).locale('th').add(543, 'year').format('LL');
                    }
                } catch (e) {
                    // If date parsing fails, return as-is
                }
            }

            return value;
        },

        formatObjectValue(parsedJson) {
            // If it's a maintenance table, format it specially
            if (Array.isArray(parsedJson) && parsedJson.length > 0 && parsedJson[0].detail_text) {
                let maintenanceHtml = '<div style="max-height: 300px; overflow-y: auto;">';
                parsedJson.forEach((item) => {
                    maintenanceHtml += `<div style="margin-bottom: 10px; padding: 8px; background-color: #f5f5f5; border-radius: 4px;">
                                <strong>ผู้รายงาน:</strong> ${item.name} (${item.tel})<br>
                                ${item.detail_text}
                                </div>`;
                });
                maintenanceHtml += '</div>';
                return maintenanceHtml;
            }

            // If it's device table, format it specially
            if (Array.isArray(parsedJson) && parsedJson.length > 0 && parsedJson[0].device_name) {
                let deviceHtml = '<table style="width: 100%; border-collapse: collapse; margin-top: 5px;">';
                deviceHtml += `<tr style="background-color: #f2f2f2;">
                     <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">อุปกรณ์</th>
                     <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">ขนาด</th>
                     <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">จำนวน</th>
                     <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">หน่วย</th>
                     </tr>`;

                parsedJson.forEach((device) => {
                    deviceHtml += `<tr>
                        <td style="padding: 8px; border: 1px solid #ddd;">${device.device_name}</td>
                        <td style="padding: 8px; border: 1px solid #ddd;">${device.size || '-'}</td>
                        <td style="padding: 8px; border: 1px solid #ddd;">${device.amount}</td>
                        <td style="padding: 8px; border: 1px solid #ddd;">${device.unit}</td>
                        </tr>`;
                });

                deviceHtml += '</table>';
                return deviceHtml;
            }

            // Format tel_detail specially
            if (Array.isArray(parsedJson) && parsedJson.length > 0 && parsedJson[0].tel !== undefined) {
                let telHtml = '<table style="width: 100%; border-collapse: collapse; margin-top: 5px;">';
                telHtml += `<tr style="background-color: #f2f2f2;">
                 <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">เบอร์มือถือ</th>
                 <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">เบอร์โทรศัพท์</th>
                 <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">ต่อ</th>
                 </tr>`;

                parsedJson.forEach((tel) => {
                    telHtml += `<tr>
                    <td style="padding: 8px; border: 1px solid #ddd;">${tel.phone || '-'}</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">${tel.tel || '-'}</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">${tel.tel_ext || '-'}</td>
                    </tr>`;
                });

                telHtml += '</table>';
                return telHtml;
            }

            // Handle organization data (single object with org_name)
            if (!Array.isArray(parsedJson) && parsedJson.org_name) {
                let html = '<table style="width: 100%; border-collapse: collapse; margin-top: 5px;">';
                html += `<tr style="background-color: #f2f2f2;">
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">หัวข้อ</th>
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">รายละเอียด</th>
        </tr>`;

                for (const [key, val] of Object.entries(parsedJson)) {
                    if (val !== null && val !== undefined) {
                        html += `<tr>
                    <td style="padding: 8px; border: 1px solid #ddd;">${this.formatKeyName ? this.formatKeyName(key) : key}</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">${
                        typeof val === 'string' && val.match(/^\d{4}-\d{2}-\d{2}/) && typeof moment !== 'undefined'
                            ? moment(val).locale('th').add(543, 'year').format('LL')
                            : val
                    }</td>
                </tr>`;
                    }
                }
                html += '</table>';
                return html;
            }

            // Handle hspLicense array - check for property existence, not value
            if (Array.isArray(parsedJson) && parsedJson.length > 0 && 'hsp_license_id' in parsedJson[0]) {
                let html = '<table style="width: 100%; border-collapse: collapse; margin-top: 5px;">';
                html += `<tr style="background-color: #f2f2f2;">
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">เลขที่ใบอนุญาต</th>
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">ลำดับที่ใบอนุญาต</th>
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">วันที่หมดอายุ</th>
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">ประเภท</th>
        </tr>`;

                parsedJson.forEach((item) => {
                    html += `<tr>
                <td style="padding: 8px; border: 1px solid #ddd;">${item.hsp_license_id || '-'}</td>
                <td style="padding: 8px; border: 1px solid #ddd;">${item.hsp_license_sequence || '-'}</td>
                <td style="padding: 8px; border: 1px solid #ddd;">${
                    item.hsp_expire_date && typeof moment !== 'undefined'
                        ? moment(item.hsp_expire_date).locale('th').add(543, 'year').format('LL')
                        : item.hsp_expire_date || '-'
                }</td>
                <td style="padding: 8px; border: 1px solid #ddd;">${item.hsp_type || '-'}</td>
            </tr>`;
                });
                html += '</table>';
                return html;
            }

            // Handle factoryLicense array - check for property existence, not value
            if (Array.isArray(parsedJson) && parsedJson.length > 0 && 'factory_license_id' in parsedJson[0]) {
                let html = '<table style="width: 100%; border-collapse: collapse; margin-top: 5px;">';
                html += `<tr style="background-color: #f2f2f2;">
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">เลขที่ใบอนุญาตโรงงาน</th>
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">ลำดับที่ใบอนุญาต</th>
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">รายละเอียด</th>
        </tr>`;

                parsedJson.forEach((item) => {
                    html += `<tr>
                <td style="padding: 8px; border: 1px solid #ddd;">${item.factory_license_id || '-'}</td>
                <td style="padding: 8px; border: 1px solid #ddd;">${item.factory_license_sequence || '-'}</td>
                <td style="padding: 8px; border: 1px solid #ddd;">${item.factory_detail || '-'}</td>
            </tr>`;
                });
                html += '</table>';
                return html;
            }

            // Handle orgBusinessDetail array - check for property existence, not value
            if (Array.isArray(parsedJson) && parsedJson.length > 0 && 'org_business_condition' in parsedJson[0]) {
                let html = '<table style="width: 100%; border-collapse: collapse; margin-top: 5px;">';
                html += `<tr style="background-color: #f2f2f2;">
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">สภาพกิจการ</th>
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">ชื่อกิจกรรม</th>
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">สถานะกิจการ</th>
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">หมายเหตุ</th>
            <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">ระดับความเสี่ยง</th>
        </tr>`;

                parsedJson.forEach((item) => {
                    html += `<tr>
                <td style="padding: 8px; border: 1px solid #ddd;">${item.org_business_condition || '-'}</td>
                <td style="padding: 8px; border: 1px solid #ddd;">${item.activity_name || '-'}</td>
                <td style="padding: 8px; border: 1px solid #ddd;">${item.org_business_status || '-'}</td>
                <td style="padding: 8px; border: 1px solid #ddd;">${item.remark || '-'}</td>
                <td style="padding: 8px; border: 1px solid #ddd;">${item.risk_level || '-'}</td>
            </tr>`;
                });
                html += '</table>';
                return html;
            }

            // For other structures, display as formatted JSON
            return `<pre style="margin: 0; max-height: 200px; overflow-y: auto; white-space: pre-wrap;">${JSON.stringify(parsedJson, null, 2)}</pre>`;
        },

        handleTabChange(newTab) {
            console.log(newTab.tab.$vnode.componentOptions.propsData.header);
        },
        // exportCSV() {
        //     debugger;
        //     this.$refs.dt.exportCSV();
        // },

        async exportCSV() {
            await this.initialAllData();
            this.$refs.dt.exportCSV();
        },

        // Doe ค้นหา  3/6

        async searchTable() {
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
            }

            this.searchTimeout = setTimeout(async () => {
                try {
                    this.loading = true;
                    this.ms = true;

                    this.lazyParams = {
                        ...this.lazyParams,
                        page: 1
                    };

                    const topicMapping = {
                        ข้อเสนอแนะ: 'suggestion',
                        ระดับสิทธิ์: 'permission',
                        ผู้ใช้งานระบบ: 'system user',
                        เมนูการใช้งาน: 'menu',
                        พื้นฐานระบบ: 'general system',
                        จังหวัด: 'province',
                        อำเภอ: 'amphur',
                        ตำบล: 'tambon',
                        พื้นที่อพยพ: 'evacuation',
                        ระดับความเสี่ยง: 'risk level',
                        พื้นที่เสี่ยงภัย: 'risk area',
                        หน่วยงาน: 'organize',
                        'ระบบป้องกัน/บรรเทาสาธารณภัย': 'prevent',
                        หลักสูตรการฝึกอบรม: 'course',
                        กำลังคน: 'officer',
                        อุปกรณ์: 'device',
                        ชุดเผชิญเหตุ: 'incident',
                        'เครื่องมือ อุปกรณ์/ยานพาหนะ': 'equipment',
                        'อาคาร/สิ่งปลูกสร้าง': 'building',
                        'UN Number (สารเคมี)': 'UN',
                        หัวจ่ายน้ำดับเพลิง: 'fire hydrant',
                        ชุมชน: 'community',
                        สถานีดับเพลิงและกู้ภัย: 'firestation',
                        'สาธารณภัย (แจ้งเหตุจากประชาชน)': 'disaster people',
                        สาธารณภัย: 'disaster',
                        ครอบครัวผู้ประสบภัย: 'family',
                        'ผู้ประสบภัย (บุคคล)': 'person',
                        'เครื่องอุปโภค บริโภค': 'consumables',
                        ถังดับเพลิง: 'extinguisher',
                        สถานีชาร์จรถยนต์ไฟฟ้า: 'EV station',
                        สถานประกอบการ: 'public organization',
                        'อาสาสมัคร อปพร.': 'volunteer',
                        จุดอาสาสมัคร: 'Volunteer Rescue',
                        คู่มือการใช้งานระบบ: 'manual',
                        'อาสาสมัคร อปพร': 'Volunteer Civil',
                        ประชาชนแจ้งเหตุ: 'Disaster (map)',
                        อาสาสมัครในพื้นที่เขตกรุงเทพมหานคร: 'Volunteer Bangkok'
                    };

                    let searchFilter = this.filter;
                    if (this.columns_topic && this.filter) {
                        const englishTerm = Object.entries(topicMapping).find(([thai]) => this.filter.includes(thai));

                        if (englishTerm) {
                            searchFilter = englishTerm[1];
                        }
                    }

                    const response = await this.axios.post(`${this.$url_service}/get/report`, {
                        body: {
                            topic: 'get-report-logs',
                            organize: this.checkPermission() ? this.selectedOrganize : this.getUserOrganize(),
                            starttime: this.actionStartTime ? moment(this.actionStartTime).format('YYYY-MM-DD HH:mm:ss') : null,
                            endtime: this.actionEndTime ? moment(this.actionEndTime).format('YYYY-MM-DD HH:mm:ss') : null,
                            pagination: {
                                page: this.lazyParams.page,
                                limit: this.lazyParams.rows
                            },
                            sort: {
                                field: this.lazyParams.sortField,
                                order: this.lazyParams.sortOrder === 1 ? -1 : 1
                            },
                            search: {
                                filter: searchFilter,
                                columns: {
                                    user_username: this.columns_user_username,
                                    user_fullname: this.columns_user_fullname,
                                    organize_name: this.columns_organize_name,
                                    action_time: this.columns_action_time,
                                    topic: this.columns_topic
                                }
                            }
                        }
                    });

                    if (response.data) {
                        this.totalRecords = response.data.total;
                        this.actionLogs_table = response.data.data.map((item, index) => ({
                            ...item,
                            index: (this.lazyParams.page - 1) * this.lazyParams.rows + index + 1,
                            action_time: moment(item.action_time).locale('th').add(543, 'year').format('LLL'),
                            topic: this.formatTopicWithPrefix(item.topic),
                            organize_name: item.organize_name || '-',
                            user_username: item.user_username || '-',
                            user_fullname: item.user_fullname || '-'
                        }));
                    }
                } catch (error) {
                    console.error('Error searching data:', error);
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to search data',
                        life: 3000
                    });
                } finally {
                    this.loading = false;
                }
            }, this.searchDelay);
        },
        // Doe ค้นหา  3/6 จบ

        async initialAllData() {
            this.filter = '';
            this.cloneTable = [];

            if (this.actionStartTime && !this.actionEndTime) {
                this.errorEndTime = true;
            } else if (!this.actionStartTime && this.actionEndTime) {
                this.errorStartTime = true;
            } else {
                this.loading = true;
                await this.axios
                    .post(`${this.$url_service}/get/report`, {
                        body: {
                            topic: 'get-all-report-logs',
                            organize: this.checkPermission() ? this.selectedOrganize : this.getUserOrganize(),
                            starttime: this.actionStartTime ? moment(this.actionStartTime).format('YYYY-MM-DD HH:mm:ss') : null,
                            endtime: this.actionEndTime ? moment(this.actionEndTime).format('YYYY-MM-DD HH:mm:ss') : null
                        }
                    })
                    .then((response) => {
                        // debugger;
                        this.actionLogs_table = response.data.data;
                        // Doe ค้นหา  4/6
                        this.cloneTable = response.data.data;
                        // Doe ค้นหา  4/6
                        // Doe : เพิ่ม ลำดับ 3/4
                        for (let i = 0; i < this.actionLogs_table.length; i++) {
                            this.actionLogs_table[i]['index'] = i + 1;
                        }
                        // Doe : เพิ่ม ลำดับ 3/4 จบ
                        // Doe : แก้ไข เวลา
                        for (let index = 0; index < this.actionLogs_table.length; index++) {
                            const element = this.actionLogs_table[index].action_time;
                            // console.log("element",element)

                            this.actionLogs_table[index].action_time = moment(element).locale('th').add(543, 'year').format('LLL');
                        }
                        // Doe : แก้ไข เวลา
                        // console.log("this.actionLogs_table ", this.actionLogs_table)

                        // Doe แก้ไข Topic
                        for (let index = 0; index < this.actionLogs_table.length; index++) {
                            const element = this.actionLogs_table[index].topic;
                            // console.log("element",element)
                            if (element.split(' ')[0] == 'Add') {
                                const Topic = this.formatTopic(element);
                                this.actionLogs_table[index].topic = `เพิ่มข้อมูล ${Topic}`;
                                // console.log("this.actionLogs_table[index].topic",this.actionLogs_table[index].topic)
                            } else if (element.split(' ')[0] == 'Edit') {
                                const Topic = this.formatTopic(element);
                                this.actionLogs_table[index].topic = `แก้ไขข้อมูล ${Topic}`;
                            } else {
                                const Topic = this.formatTopic(element);
                                this.actionLogs_table[index].topic = `ลบข้อมูล ${Topic}`;
                            }
                        }

                        // Doe ช่องว่างใส่ ขีด
                        for (let index = 0; index < this.actionLogs_table.length; index++) {
                            if (
                                this.actionLogs_table[index].organize_name == null ||
                                this.actionLogs_table[index].organize_name == 'null' ||
                                this.actionLogs_table[index].organize_name == ''
                            ) {
                                this.actionLogs_table[index].organize_name = '-';
                            }
                            if (
                                this.actionLogs_table[index].user_username == null ||
                                this.actionLogs_table[index].user_username == 'null' ||
                                this.actionLogs_table[index].user_username == ''
                            ) {
                                this.actionLogs_table[index].user_username = '-';
                            }
                            if (
                                this.actionLogs_table[index].user_fullname == null ||
                                this.actionLogs_table[index].user_fullname == 'null' ||
                                this.actionLogs_table[index].user_fullname == ''
                            ) {
                                this.actionLogs_table[index].user_fullname = '-';
                            }
                        }
                        // Doe ช่องว่างใส่ ขีด

                        this.setSearchText_Footer();
                    });

                if (this.columns_disabled == true) {
                    this.actionLogs_table = this.cloneTable;
                } else {
                    this.actionLogs_table = [];
                }

                this.loading = false;
            }
        },

        //pagination
        async initialData() {
            this.lazyParams = {
                page: 1,
                rows: 10,
                sortField: 'index',
                sortOrder: 1
            };
            await this.loadData();
        },

        async loadData() {
            try {
                this.loading = true;
                const response = await this.axios.post(`${this.$url_service}/get/report`, {
                    body: {
                        topic: 'get-report-logs',
                        organize: this.checkPermission() ? this.selectedOrganize : this.getUserOrganize(),
                        starttime: this.actionStartTime ? moment(this.actionStartTime).format('YYYY-MM-DD HH:mm:ss') : null,
                        endtime: this.actionEndTime ? moment(this.actionEndTime).format('YYYY-MM-DD HH:mm:ss') : null,
                        pagination: {
                            page: this.lazyParams.page,
                            limit: this.lazyParams.rows // Use rows as limit
                        },
                        sort: {
                            field: this.lazyParams.sortField,
                            order: this.lazyParams.sortOrder === 1 ? -1 : 1
                        }
                    }
                });

                if (response.data) {
                    this.totalRecords = response.data.total;
                    this.actionLogs_table = response.data.data.map((item, index) => ({
                        ...item,
                        index: (this.lazyParams.page - 1) * this.lazyParams.rows + index + 1,
                        action_time: moment(item.action_time).locale('th').add(543, 'year').format('LLL'),
                        topic: this.formatTopicWithPrefix(item.topic),
                        organize_name: item.organize_name || '-',
                        user_username: item.user_username || '-',
                        user_fullname: item.user_fullname || '-'
                    }));
                }
            } catch (error) {
                console.error('Error loading data:', error);
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to load data',
                    life: 3000
                });
            } finally {
                this.loading = false;
            }
        },

        onPage(event) {
            this.lazyParams = {
                ...this.lazyParams,
                page: event.page + 1,
                rows: event.rows // Update rows when page size changes
            };
            this.loadData();
        },

        onSort(event) {
            this.lazyParams = {
                ...this.lazyParams,
                sortField: event.sortField,
                sortOrder: event.sortOrder
            };
            this.loadData();
        },

        // Helper method to format topic
        formatTopicWithPrefix(topic) {
            const [action, ...rest] = topic.split(' ');
            const topicText = this.formatTopic(rest.join(' '));

            switch (action) {
                case 'Add':
                    return `เพิ่มข้อมูล ${topicText}`;
                case 'Edit':
                    return `แก้ไขข้อมูล ${topicText}`;
                case 'Delete':
                    return `ลบข้อมูล ${topicText}`;
                default:
                    return topic;
            }
        },

        async loadMoreData() {
            if (this.loading) return;

            this.page++;
            this.loading = true;

            try {
                const response = await this.axios.post(`${this.$url_service}/get/report`, {
                    body: {
                        topic: 'get-report-logs',
                        organize: this.checkPermission() ? this.selectedOrganize : this.getUserOrganize(),
                        starttime: this.actionStartTime ? moment(this.actionStartTime).format('YYYY-MM-DD HH:mm:ss') : null,
                        endtime: this.actionEndTime ? moment(this.actionEndTime).format('YYYY-MM-DD HH:mm:ss') : null,
                        page: this.page,
                        limit: this.limit
                    }
                });

                const newData = response.data.data.map((item, index) => ({
                    ...item,
                    index: (this.page - 1) * this.limit + index + 1,
                    action_time: moment(item.action_time).locale('th').add(543, 'year').format('LLL'),
                    topic: this.formatTopicWithPrefix(item.topic),
                    organize_name: item.organize_name || '-',
                    user_username: item.user_username || '-',
                    user_fullname: item.user_fullname || '-'
                }));

                this.actionLogs_table = [...this.actionLogs_table, ...newData];
                this.cloneTable = [...this.actionLogs_table];
            } catch (error) {
                console.error('Error loading more data:', error);
            } finally {
                this.loading = false;
            }
        },

        setSearchText_Footer() {
            this.text_Footer = false;

            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            if (this.selectedOrganize.name !== '' || this.actionStartTime !== null || this.actionEndTime !== null) {
                for (let index = 0; index < this.Data_text_Footer.length; index++) {
                    const element = this.Data_text_Footer[index];
                    if (element.DataName === 'สังกัด' && this.selectedOrganize.name !== '') {
                        element.textShow = this.selectedOrganize.name;
                    }
                    if (element.DataName === 'เวลาเริ่มต้น' && this.actionStartTime !== null) {
                        element.textShow = this.setDate(this.actionStartTime);
                    }
                    if (element.DataName === 'เวลาสิ้นสุด' && this.actionEndTime !== null) {
                        element.textShow = this.setDate(this.actionEndTime);
                    }

                    this.text_Footer = true;
                }
            }
        },
        setDate(date) {
            if (typeof date === 'object') {
                const Thai_date = date.toLocaleDateString('th-TH', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric'
                });
                return Thai_date;
            } else {
                return date;
            }
        },
        selectedOrganize_passValue(variable) {
            this.selectedOrganize = {
                id: variable.organize_id,
                name: variable.organize_name
            };
        },

        clearSearchField() {
            this.selectedOrganize = { id: null, name: '' };
            this.actionStartTime = null;
            this.actionEndTime = null;
            this.initialData();
            this.filter = '';
            this.cloneTable = [];
            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            this.text_Footer = false;
        },

        // Doe PDF เลือกได้  5/5
        EditPDF() {
            this.displayEditPDF = true;
            this.columnsSelectorDialog = this.columnsSelector;
        },
        SaveEditPDF() {
            if (this.columnsSelectorDialog.length <= 4) {
                this.PDF_minCellWidthVer = 120;
                this.PDF_FontHeaderVer = 15;
                this.PDF_FontBodyVer = 12;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 }
                };

                this.PDF_minCellWidthHor = 130;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 }
                };
            } else if (this.columnsSelectorDialog.length <= 6) {
                this.PDF_minCellWidthVer = 70;
                this.PDF_FontHeaderVer = 15;
                this.PDF_FontBodyVer = 12;
                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 },
                    user_fullname: { cellWidth: 80 }
                };

                this.PDF_minCellWidthHor = 90;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 }
                };
            }

            this.columnsSelector = this.columnsSelectorDialog;

            if (this.columnsSelectorDialog.length == 0) {
                this.columns_index = false;
                this.columns_user_username = false;
                this.columns_user_fullname = false;
                this.columns_organize_name = false;
                this.columns_action_time = false;
                this.columns_topic = false;
                this.columns_detail = false;

                this.columns_disabled = false;
            } else if (this.columnsSelectorDialog.length == 6) {
                this.columns_index = true;
                this.columns_user_username = true;
                this.columns_user_fullname = true;
                this.columns_organize_name = true;
                this.columns_action_time = true;
                this.columns_topic = true;
                this.columns_detail = true;

                this.columns_disabled = true;
            } else {
                this.columns_disabled = true;
                // console.log('this.columnsSelectorDialog =', this.columnsSelectorDialog);

                let getData = [];
                // ! จัดข้อมูล
                for (let index = 0; index < this.columnsSelector.length; index++) {
                    getData.push(this.columnsSelector[index].dataKey);
                }

                // console.log("getData",getData);

                // ! เช็คข้อมูล

                for (let index = 0; index < this.columnsSelector.length; index++) {
                    const element = this.columnsSelector[index].dataKey;

                    if (element == 'index') {
                        this.columns_index = true;
                    } else if (!getData.includes('index')) {
                        // console.log("getData.includes(index)",getData.includes("index"))
                        this.columns_index = false;
                    }

                    if (element == 'user_username') {
                        this.columns_user_username = true;
                    } else if (!getData.includes('user_username')) {
                        this.columns_user_username = false;
                    }

                    if (element == 'user_fullname') {
                        this.columns_user_fullname = true;
                    } else if (!getData.includes('user_fullname')) {
                        this.columns_user_fullname = false;
                    }

                    if (element == 'organize_name') {
                        this.columns_organize_name = true;
                    } else if (!getData.includes('organize_name')) {
                        this.columns_organize_name = false;
                    }

                    if (element == 'action_time') {
                        this.columns_action_time = true;
                    } else if (!getData.includes('action_time')) {
                        this.columns_action_time = false;
                    }

                    if (element == 'topic') {
                        this.columns_topic = true;
                    } else if (!getData.includes('topic')) {
                        this.columns_topic = false;
                    }
                }
            }

            this.displayEditPDF = false;
            this.filter = '';
        },
        CloseEditPDF() {
            this.displayEditPDF = false;
        },
        ClearEditPDF() {
            this.columnsSelectorDialog = [];
        },
        SelectAllEditPDF() {
            this.columnsSelectorDialog = this.columns;
        }
        // Doe PDF เลือกได้  5/5 จบ
    }
};
</script>

<style scoped>
.table_row {
    text-align: center;
}
@media screen and (min-width: 819px) and (max-width: 1200px) {
    #Search {
        width: 20rem;
    }
}
/* // Doe PDF เลือกได้ */
#TABLE_EDIT {
    width: 149px;
}

@media screen and (max-width: 818px) {
    #Search {
        width: 100%;
    }
}

.p-field {
    margin-bottom: 0rem;
}
</style>

<style>
.p-datatable-thead {
    border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
    border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
.p-multiselect {
    min-width: 15rem;
}

.multiselect-custom {
    // Doe PDF เลือกได้
    width: 100%;
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }

    .item {
        display: flex;
        align-items: center;
    }

    .item-value {
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 3px;
        display: inline-flex;
        margin-right: 0.5rem;
        background-color: var(--primary-color);
        color: var(--primary-color-text);
    }
}
</style>
